import React, { Component } from 'react';
import './FormError.css';

class FormError extends Component {
  render() {
    if (!this.props.text) {
      return null;
    }
    return (
      <div className = "FormError">
        <ul>
          {
            this.props.text.map(function(errorMessage, i) {
              return <li key = {i}>{errorMessage}</li>;
            })
          }
        </ul>
      </div>
    );
  }
}

export default FormError;



// WEBPACK FOOTER //
// ./src/ui/FormError.js